/* Richard van der Meer — globale scripts (menu + lightbox) */
(function () {
  'use strict';

  /* ---------- Gedeelde scroll-vergrendeling ----------
     Vergrendelt het scrollen van de pagina (menu/lightbox open)
     zonder de positie van de sticky header te verstoren. */
  var vergrendelingen = 0;

  function vergrendelScroll() {
    vergrendelingen++;
    document.documentElement.classList.add('is-vergrendeld');
  }

  function ontgrendelScroll() {
    vergrendelingen = Math.max(0, vergrendelingen - 1);
    if (vergrendelingen === 0) {
      document.documentElement.classList.remove('is-vergrendeld');
    }
  }

  /* ---------- Mobiel menu ---------- */
  var menuKnop = document.querySelector('[data-menu-knop]');
  var mobielMenu = document.querySelector('[data-mobiel-menu]');
  var menuOpen = false;

  function zetMenu(open, focusTerug) {
    if (!menuKnop || !mobielMenu || open === menuOpen) return;
    menuOpen = open;
    mobielMenu.classList.toggle('is-open', open);
    menuKnop.setAttribute('aria-expanded', open ? 'true' : 'false');
    menuKnop.setAttribute('aria-label', open ? 'Menu sluiten' : 'Menu openen');
    if (open) {
      vergrendelScroll();
    } else {
      ontgrendelScroll();
      if (focusTerug) menuKnop.focus();
    }
  }

  if (menuKnop && mobielMenu) {
    menuKnop.addEventListener('click', function () {
      zetMenu(!menuOpen, false);
    });

    // Sluiten na het kiezen van een menu-item (ook bij ankers op dezelfde pagina)
    mobielMenu.addEventListener('click', function (e) {
      if (e.target.closest('a')) zetMenu(false, false);
    });

    // Sluiten met Escape
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menuOpen) zetMenu(false, true);
    });

    // Sluiten bij tikken buiten de header
    document.addEventListener('click', function (e) {
      if (menuOpen && !e.target.closest('.kop')) zetMenu(false, false);
    });

    // Netjes opruimen wanneer het scherm naar desktopbreedte gaat (b.v. tablet draaien)
    var desktopQuery = window.matchMedia('(min-width: 861px)');
    function bijBreedteWissel(mq) {
      if (mq.matches) zetMenu(false, false);
    }
    if (desktopQuery.addEventListener) desktopQuery.addEventListener('change', bijBreedteWissel);
    else if (desktopQuery.addListener) desktopQuery.addListener(bijBreedteWissel);
  }

  /* ---------- Lightbox voor galerijen ---------- */
  var items = Array.prototype.slice.call(document.querySelectorAll('[data-lightbox-item]'));
  if (!items.length) return;

  var overlay = document.createElement('div');
  overlay.className = 'lightbox';
  overlay.setAttribute('role', 'dialog');
  overlay.setAttribute('aria-modal', 'true');
  overlay.setAttribute('aria-label', 'Projectfoto vergroot weergegeven');
  overlay.innerHTML =
    '<button type="button" class="lightbox__knop lightbox__sluit" data-lb-sluit aria-label="Sluiten">' + icoon('kruis') + '</button>' +
    '<button type="button" class="lightbox__knop lightbox__vorige" data-lb-vorige aria-label="Vorige foto">' + icoon('links') + '</button>' +
    '<img alt="">' +
    '<button type="button" class="lightbox__knop lightbox__volgende" data-lb-volgende aria-label="Volgende foto">' + icoon('rechts') + '</button>' +
    '<div class="lightbox__label" data-lb-label></div>';
  document.body.appendChild(overlay);

  var lbImg = overlay.querySelector('img');
  var lbLabel = overlay.querySelector('[data-lb-label]');
  var huidig = 0;
  var vorigeFocus = null;

  function icoon(soort) {
    if (soort === 'kruis') return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M5 5l14 14M19 5 5 19"/></svg>';
    if (soort === 'links') return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>';
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m9 5 7 7-7 7"/></svg>';
  }

  function toon(index) {
    huidig = (index + items.length) % items.length;
    var item = items[huidig];
    lbImg.src = item.getAttribute('data-groot');
    lbImg.alt = item.getAttribute('data-alt') || '';
    lbLabel.textContent = item.getAttribute('data-label') || '';
    lbLabel.style.display = lbLabel.textContent ? '' : 'none';
    var meerdere = items.length > 1;
    overlay.querySelector('[data-lb-vorige]').style.display = meerdere ? '' : 'none';
    overlay.querySelector('[data-lb-volgende]').style.display = meerdere ? '' : 'none';
  }

  function open(index) {
    vorigeFocus = document.activeElement;
    toon(index);
    overlay.classList.add('is-open');
    vergrendelScroll();
    overlay.querySelector('[data-lb-sluit]').focus();
  }

  function sluit() {
    overlay.classList.remove('is-open');
    ontgrendelScroll();
    lbImg.src = '';
    if (vorigeFocus && vorigeFocus.focus) vorigeFocus.focus();
  }

  items.forEach(function (item, i) {
    item.addEventListener('click', function () { open(i); });
  });

  overlay.addEventListener('click', function (e) {
    if (e.target === overlay || e.target === lbImg) { sluit(); return; }
    if (e.target.closest('[data-lb-sluit]')) sluit();
    if (e.target.closest('[data-lb-vorige]')) toon(huidig - 1);
    if (e.target.closest('[data-lb-volgende]')) toon(huidig + 1);
  });

  /* Veeggebaren op aanraakschermen: links/rechts bladeren, omlaag vegen sluit */
  var raakStartX = 0;
  var raakStartY = 0;
  var raakActief = false;

  overlay.addEventListener('touchstart', function (e) {
    if (e.touches.length !== 1) { raakActief = false; return; }
    raakActief = true;
    raakStartX = e.touches[0].clientX;
    raakStartY = e.touches[0].clientY;
  }, { passive: true });

  overlay.addEventListener('touchend', function (e) {
    if (!raakActief || items.length === 0) return;
    raakActief = false;
    var dx = e.changedTouches[0].clientX - raakStartX;
    var dy = e.changedTouches[0].clientY - raakStartY;
    if (Math.abs(dx) > 48 && Math.abs(dx) > Math.abs(dy) * 1.4) {
      if (items.length > 1) toon(dx < 0 ? huidig + 1 : huidig - 1);
    } else if (dy > 72 && Math.abs(dy) > Math.abs(dx) * 1.4) {
      sluit();
    }
  }, { passive: true });

  document.addEventListener('keydown', function (e) {
    if (!overlay.classList.contains('is-open')) return;
    if (e.key === 'Escape') sluit();
    if (e.key === 'ArrowLeft') toon(huidig - 1);
    if (e.key === 'ArrowRight') toon(huidig + 1);
    if (e.key === 'Tab') {
      // Focus binnen de lightbox houden
      var focusbaar = overlay.querySelectorAll('button:not([style*="display: none"])');
      var eerste = focusbaar[0];
      var laatste = focusbaar[focusbaar.length - 1];
      if (e.shiftKey && document.activeElement === eerste) { e.preventDefault(); laatste.focus(); }
      else if (!e.shiftKey && document.activeElement === laatste) { e.preventDefault(); eerste.focus(); }
    }
  });
})();
